@if (store$ | async; as store) {
  <igo-catalog-browser
    [catalog]="catalog"
    [store]="store"
    [map]="map"
    [toggleCollapsedGroup]="toggleCollapsedGroup()"
  />
}
